<template>
    <div>
        <h1>Admin Dashboard</h1>
    </div>
</template>

<script setup>

</script>